<template>
  <div class="home-container text-center speaker-home">
    <div :span="24" class="text--center">
      <h2 class="app__title">
        {{ $t("program.program") }}
      </h2>
    </div>
    <el-skeleton :rows="4" animated />
  </div>
</template>
